/*! @miragon/context-maps-renderer notation glyphs
 * Material Icons star and pan_tool @license Apache-2.0
 * Copyright Google LLC */

/**
 * Kaiser's subdomain glyphs on a 24×24 viewBox: a filled star for a core domain, an open hand for a
 * supporting subdomain (a generic subdomain draws a dotted circle). They are notation, not function
 * icons, so they keep their filled shapes instead of Lucide outlines (guide §3.6, §11). The paths are
 * Material Icons `star` and `pan_tool`.
 */
export const STAR_PATH =
  "M12 2l2.9 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 7.1-1.01z";
export const HAND_PATH =
  "M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z";
